<!-- eslint-disable vue/no-v-html -->
<template>
	<div class="email-card-list">
		<div v-if="showHeader" class="font-bold pt-3 pb-1 px-4">Send Emails</div>
		<CCardList
			class="c-email-notifications c-notification-section"
			add-text="Add Email"
			:allow-drag="false"
			@add="$emit('add-email')"
		>
			<CCard
				v-for="email in emails"
				:key="email.Id"
				:title="email.subjectHtml"
				:can-delete="true"
				:icon="getIcon(email)"
				@click="$emit('edit-email', email.index)"
				@delete="$emit('email-deleted', email.index)"
			>
				<template v-if="email.hasErrors" #prefix>
					<Inline svg="error" class="!text-icon-error" />
				</template>
				<template #bottom>
					<div class="email-card-list__recipients">
						<span class="email-card-list__recipient-label">To: </span>
						<span
							class="email-card-list__recipient-list"
							v-html="getRecipientsHtml(email)"
						/>
						<Inline
							v-if="getRoleIcon(email)"
							:svg="getRoleIcon(email)"
							class="email-card-list__role-icon text-icon-subtle"
						/>
					</div>
					<div v-if="showWhen">
						When: {{ email.sendWhenPreview }}
					</div>
				</template>
			</CCard>
			<template v-if="errorMessage" #errorMessageBox>
				<div class="c-validation">
					{{ errorMessage }}
				</div>
			</template>
		</CCardList>
	</div>
</template>

<script>
	import CCard from 'src/components/app/Card.vue';
	import CCardList from 'src/components/lists/CardList.vue';
	export default {
		name: 'EmailCardList',
		components: {
			CCard,
			CCardList
		},
		props: {
			emails: {
				type: Array,
				default: () => []
			},
			showWhen: {
				type: Boolean,
				default: true
			},
			maxEmails: {
				type: Number,
				default: null
			},
			showHeader: {
				type: Boolean,
				default: false
			}
		},
		computed: {
			errorMessage() {
				// If maxEmails implicit boolean value is false and the literal value is not 0
				// or if there less emails than the maximum number of emails allowed
				// then there is no error message
				if ((!this.maxEmails && this.maxEmails !== 0) || this.emails.length <= this.maxEmails) {
					return null;
				}

				// Handle the case where there are more emails than the maximum number of emails allowed
				switch (this.maxEmails) {
				case 1:
					return 'Upgrade to send more than one email.';
				case 2:
					return 'Upgrade to send more than two emails.';
				default:
					return null;
				}
			}

		},
		methods: {
			getRecipientsHtml(email) {
				const toHtml = email?.toHtml || '';
				return toHtml.replace(/^<span>To:\s*<\/span>/i, '');
			},
			getRoleIcon(email) {
				return email?.roleIcon || null;
			},
			getIcon(email) {
				if (email.hasErrors)
					return null;
				return 'email';
			}
		}
	};
</script>

<style lang="scss">
.email-card-list {

	.c-email-notifications {

		.c-validation {
			margin: 8px 0 0;
		}
	}

	.card__inner-content > div:not(.card__prefix) {
		min-width: 0;
	}

	&__role-icon {
		flex: none;
	}

	.card__inner-content .card__bottom &__recipients {
		display: flex;
		align-items: flex-start;
		gap: $space__2;
		white-space: normal;
	}

	&__recipient-list {
		min-width: 0;
		max-width: 13em;
		overflow-wrap: anywhere;
		white-space: normal;
	}

	&__recipient-label {
		flex: none;
		white-space: nowrap;
	}
}

</style>
